import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class Tenant_Settings extends Component {
	constructor(props) {
		super(props);

		let tenant_info = this.props.param.tenant_info;
		if (tenant_info == null) tenant_info = {};
		this.tenant_info = tenant_info;
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Billing_Main');
	}

	handleAddTenant = () => {
		this.menu_selection = "add_tenant";
		window.app.showLoading();
		this.props.receiver.loadPPDPointList();
	}

	//Access to edit tenant information
	accessTenant = (tenant_name) => {
		this.menu_selection = "edit_tenant";
		this.tenant_name = tenant_name
		window.app.showLoading();
		this.props.receiver.loadPPDPointList();
	}

	//Response from controller - retrieve all ppd point list
	rcvLoadPPDPointList = (ppd_point_list) => {
		window.app.hideLoading();
		if (ppd_point_list != null) {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			if (this.menu_selection == 'add_tenant') this.props.content_handler('Add_Edit_Tenant', { from: this.menu_selection, ppd_point_list: ppd_point_list, tenant_info: this.tenant_info });
			else this.props.content_handler('Add_Edit_Tenant', { from: this.menu_selection, ppd_point_list: ppd_point_list, tenant_name: this.tenant_name, tenant_info: this.tenant_info });
		}
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let biling_info_container = {
			marginLeft: 5,
			maxWidth: '60%',
			width: '60%',
			textAlign: 'left',
		}

		let billing_options_name = {
			fontSize: 16,
			color: 'black',
			fontWeight: 'bold',
			padding: 0,
			margin: 5,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		}

		let container_style = {
			paddingLeft: 20,
			paddingRight: 20,
			justifyContent: 'center',
			alignItems: 'center',
			height: this.props.height - 100,
			overflow: 'auto',
			paddingBottom: window.innerWidth > window.innerHeight ? 20 : 0
		}

		let billing_container = {
			cursor: 'pointer',
			backgroundColor: '#f9f9f9',
			borderRadius: 10,
			maxWidth: '100%',
			width: 'auto',
			alignItems: 'center',
			justifyContent: 'left',
			position: 'relative',
			display: 'flex',
			marginTop: 10,
			marginBottom: 10,
			padding: 10
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('tenant_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddTenant}
					/>

					{/* List of tenants */}
					<div style={container_style}>
						<div id="deviceContainer">
							{Object.keys(this.tenant_info).map((tenant_name, index) => {
								return (
									<div style={billing_container} id={index} onClick={() => { this.accessTenant(tenant_name) }}>
										<div style={biling_info_container}>
											<p style={billing_options_name}>{tenant_name}</p>
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}